import React from "react";
import Button from "@mui/material/Button";
import { useNavigate} from "react-router-dom";
import { useSelector } from "react-redux";
import useRudderStackAnalytics from "../../config/useRudderAnalytics";
export default function ReportHome(){
    const useRudderAnalytics=useRudderStackAnalytics();
    const navigate=useNavigate();
    const driverName=useSelector(state=>state.driver.entities.currDriver?.driverName);
    const driverId=useSelector(state=>state.driver.entities.currDriver?.driverId);
    React.useEffect(()=>{
        if(useRudderAnalytics && driverId){
            useRudderAnalytics.page("Vehicle Temp Home")
        }
    },[useRudderAnalytics, driverId])
    return (
        <>
            {driverId&&<div style={{display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"column",overflow:"hidden"}}>
                <p style={{fontStyle:"italic"}}>You are currently logged in as:</p>
                <h3 style={{textDecoration:"underline"}}>{driverName}</h3>
            </div>}
            {!driverId&&<div style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center", height:"80vh", flexDirection:"column",overflow:"hidden"}}>
                <p style={{fontStyle:"italic"}}>You are not logged in, please enter valid URL or contact your manager</p>
            </div>}
            <div style={{display:"flex", justifyContent:"center", alignItems:"center", gap:"40px", flexDirection:"column", height:"50vh", overflow:"hidden"}}>
            <Button onClick={()=>navigate("create")} style={{width:"fit-content", minWidth:"150px", maxWidth:"90%", minHeight:"60px", fontSize:"1rem"}} variant="contained">Create</Button>
            <Button onClick={(()=>navigate("view"))} style={{width:"fit-content", minWidth:"150px", maxWidth:"90%", minHeight:"60px", fontSize:"1rem"}} variant="contained">View</Button>
            </div>
        </>
    )
}